<template>
    <div class="widget">
        <loading-indicator v-if="loading"/>
        <template v-else>
            <div class="widget-title" v-if="$scopedSlots.title || title">
                <slot name="title">{{ title }}</slot>
            </div>
            <slot/>
        </template>
    </div>
</template>

<style lang="scss">
    .widget {
        padding: $spacer-3;
        background-color: $white;
        box-shadow: $layout-shadow;
        font-size: $font-size-sm;

        &:not(:last-child) {
            margin-bottom: $spacer-2;
        }
    }
    .widget-title {
        margin-bottom: 0;
        color: $red;
        font-size: .875rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: $spacer-2;
    }
</style>

<script>
    export default {
        props: {
            title: {type: String, default: null},
            loading: {type: Boolean, default: false},
        },
    };
</script>